export type {
  DrawerHeaderNavigationProps,
  DrawerHeaderNavigationSlots,
  DrawerHeaderNavigationState,
} from '@fluentui/react-drawer';
